import React, { Component } from 'react';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import SuperMoyaEmailConfirmationContainer from './containers/SuperMoyaEmailConfirmationContainer';
import SuperMoyaSettlementConfirmationContainer from './containers/SuperMoyaSettlementConfirmationContainer';
import SuperMoyaUnsubscribeContainer from './containers/SuperMoyaUnsubscribeContainer';
import SuperMoyaSettlementRejectContainer from './containers/SuperMoyaSettlementRejectContainer';
import SuperMoyaMoyaPayEmailConfirmationContainer from './containers/SuperMoyaMoyaPayEmailConfirmationContainer';

class App extends Component {
    render() {
        return (
            <React.Fragment>
                <Router>
                    <div className={'app'}>
                        <main>
                            <Switch>
                                <Route
                                    path='/email-confirm/:token'
                                    render={(props) => <SuperMoyaEmailConfirmationContainer token={props.match.params.token} {...props} />}
                                />
                                <Route
                                    path='/moya-pay-email-confirm/:token'
                                    render={(props) => <SuperMoyaMoyaPayEmailConfirmationContainer token={props.match.params.token} {...props} />}
                                />
                                <Route
                                    path='/settlement-confirm/:token'
                                    render={(props) => (
                                        <SuperMoyaSettlementConfirmationContainer token={props.match.params.token} {...props} />
                                    )}
                                />
                                <Route
                                    path='/settlement-reject/:token'
                                    render={(props) => (
                                        <SuperMoyaSettlementRejectContainer token={props.match.params.token} {...props} />
                                    )}
                                />
                                <Route
                                    path='/unsubscribe/:token'
                                    render={(props) => <SuperMoyaUnsubscribeContainer token={props.match.params.token} {...props} />}
                                />
                            </Switch>
                        </main>
                    </div>
                </Router>
            </React.Fragment>
        );
    }
}

export default App;
